module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/add-variant-price-box/add-variant-price-box.component.scss
// module id = ./src/app/modules/backstage-module/common/add-variant-price-box/add-variant-price-box.component.scss
// module chunks = 9